import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SearchRecord, VendorResponseTypes, SearchVendors } from '../../models/searchPackage';
import { SearchPackageService } from 'src/app/services/search-package.service';
import { NgForm } from '@angular/forms';
import { Subscription } from 'rxjs';
import { ObjectUpdatePayload } from 'src/app/models/screeningInvite';
import { AuthService } from 'src/app/services/auth.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-search-management-dialog',
  templateUrl: './search-management-dialog.component.html',
  styleUrls: ['./search-management-dialog.component.less']
})
export class SearchManagementDialogComponent implements OnInit {

  @Input() public search : SearchRecord;
  @ViewChild('form', {}) ngForm: NgForm;
 
  constructor(public modalService: NgbModal,
    public searches : SearchPackageService,
    public auth : AuthService,
    public toast : ToastrService) { }

  ngOnInit() {
   
  }

  getcountiesforState(state : string){
    return this.searches.stateData.filter(sd =>{return sd.stateAbbr == state}).map(s =>{return s.countyName;});
  }

  public get manualTriggerLock(): boolean {
    return !(this.search.searchType === VendorResponseTypes.Eviction && this.search.vendor === SearchVendors.Cleara);
  }

  updateCreditVendor()
  {
    if(this.search.vendor == SearchVendors.Equifax){
      this.search.includeFICO = false;
      this.search.searchMeta.repository = 0;
    }else if(this.search.vendor == SearchVendors.Transunion)
    {
      this.search.searchMeta.repository = 2;
    }
    console.log('Credit Search Vendor updated',this.search)
  }

  save(){
    if(this.ngForm.valid){
      this.searches.UpdateSearch(this.search).subscribe((scc: any)=>{
        if(scc)
          this.toast.success('Package updated Successfully');
        else
          this.toast.error('Errror Updating Search Package');
      },(err: any)=>{
        this.toast.error('Errror Updating Search Package');
      });
      this.modalService.dismissAll();
    }
  }
}
